export const Tab = () => null;
Tab.displayName = 'Tab';
//# sourceMappingURL=Tab.js.map